module.exports = __webpack_public_path__ + "static/media/circle_check.30105859.svg";